<script setup>

</script>

<template>
  <h2>
    Dziękujemy za płatność!
  </h2>
  <div class="wrapper">
    <div class="wrapper__image-aside">
      <img src="@/assets/pies.png" alt="">
    </div>
    <div class="container">
      Dziękujemy za zakup subskrypcji! Płatność została przetworzona pomyślnie. Możesz teraz korzystać z pełnych funkcjonalności subskrypcji dla biznesu.

      <button>
        <router-link to="/dla-biznesu/profile">Przejdź do profilu</router-link>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  text-align: center;
  font-size: 3.5rem;
}

.wrapper{
  display: flex;
  justify-content: center;
  gap: 80px;
  &__image-aside{
    width: 250px;
    img{
      width: 100%;
    }
    flex: 1;
  }

  .container{
    flex: 2;
  }
}

button{
  background-color: #F2790F;
  padding: 8px 15px;
  border-radius: 8px;
  border: none;
  margin-top: 20px;
  a {
    text-decoration: none;
    color: black;
  }
}
</style>